import BaseComponent from "../../../lib/components/BaseComponent";

import MuiModal from '@mui/material/Modal'
import {Paper} from "@mui/material";

const style = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', boxShadow: 24, p: 4,
};
export default class Modal extends BaseComponent {

  render() {
    return <MuiModal open={true}>
      <Paper sx={style}>
        {this.props.children}
      </Paper>
    </MuiModal>;
  }

}